import axios from 'axios';

const middlewareUrl = 'https://bugatchi-filters-collection.herokuapp.com'; // HEROKU
// const middlewareUrl = 'http://3.208.31.110:7500'; // AWS - STAGE
// const middlewareUrl = 'http://54.227.233.117:7500'; // AWS - PROD

const rebuyUrl = 'https://rebuyengine.com/api/v1/products';
const rebuyApiKey = '7cd704581decaa9b58f13acf1a30adcaba88e53e';
export const storefrontApiKey = 'ec8327db27d6cc7c87157bb7b77a92cb';

const storefrontConfig = {
  url: 'https://bugatchi-group-inc.myshopify.com/api/2023-07/graphql.json',
  method: 'POST',
  headers: {
    'Content-type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': storefrontApiKey,
  },
};

const createParamsString = (paramsObj) => (
  Object.entries(paramsObj).map(([name, val]) => `${name}=${val}`).join('&')
);

function parseGraphQlId (id) {
  try {
    const parsedId = atob(id).split('/');
    return +parsedId[parsedId.length - 1];
  } catch (error) {
    const parsedId = id.split('/');
    return +parsedId[parsedId.length - 1]
  }
};

const structureMetafields = (edges) => (
  edges.map(({ node }) => {
    const metafields = {};
    node.metafields.forEach(meta => {
      if (!meta?.key) return;
      metafields[meta.key] = meta.value
    })
    return {
      productId: parseGraphQlId(node.id),
      metafields,
    };
  })
);

export const searchProducts = async ({ params, data }) => {
  const urlParams = createParamsString(params);
  return await axios({
    method: 'POST',
    data,
    url: `${middlewareUrl}/products?${urlParams}`,
  });
};

const createProductIdsQuery = (products) => (
  products.map((el) => `id:${typeof el === 'object' ? el.id : el}`).join(' OR ')
);

export const retreiveProductMetafields = async (products) => {
  const query = `
    {
      products(first: ${products.length}, query: "${createProductIdsQuery(products)}") {
        edges {
          node {
            id
            metafields(
              identifiers: [
                { namespace: "global", key: "metafield_video_url" },
                { namespace: "global", key: "metafield_product_handle" },
                { namespace: "global", key: "colors_available_message_meta" },
                { namespace: "pdp", key: "activation_date" }
              ]
            ) {
              namespace
              key
              value
            }
          }
        }
      }
    }
  `;
  const { data: { data } } = await axios({
    ...storefrontConfig,
    data: query,
  });
  const structuredList = structureMetafields(data.products.edges);
  return structuredList;
};

export const fetchFilteredProductsByCollection = async ({
  filters,
  allFilters,
  collectionId,
  productsCount,
  page,
  sort,
}) => {
  const url = `${middlewareUrl}/products/${collectionId}?itemsPerView=${productsCount}&page=${page}${sort ? `&sort=${sort}` : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ filters, allFilters }),
  });
  const data = await response.json();
  return data.data;
};

const fetchStorefrontProducts = async (query) => {
  const { data: { data } } = await axios({
    ...storefrontConfig,
    data: query,
  });
  return restructureStorefrontProducts(data.products.edges);
};

export const fetchProductsById = async (products) => {
  const query = `
    {
      products(first: ${products.length}, query: "${createProductIdsQuery(products)}") {
        ${createProductItemBody()}
      }
    }
  `;
  const response = await fetchStorefrontProducts(query);
  return response;
};

export const createProductItemBody = (variantsCount = 25) => `
  pageInfo {
    hasNextPage
    hasPreviousPage
  }
  edges {
    cursor
    node {
      id
      availableForSale
      handle
      productType
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        minVariantPrice {
            amount
            currencyCode
        }
        maxVariantPrice {
            amount
            currencyCode
        }
      }
      title
      tags
      variants(first: ${variantsCount}) {
        edges {
          node {
            id
            title
            availableForSale
            quantityAvailable
            priceV2 {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            sku
          }
        }
      }
      images(first: 2) {
        edges {
          node {
            originalSrc
            altText
          }
        }
      }
      options {
        values
        name
      }
    }
  }
`;

export const fetchProductRecommendations = async (productId, limit) => {
  try {
    const url = window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`;
    const response = await fetch(url);
    const { products } = await response.json();
    return fetchProductsById(products);
  } catch (error) {
    console.error(error);
  }
};

export const restructureRestProducts = (products) => (
  products.map((product) => {
    const notAvailable = product.variants.every(v => !(!!v.inventory_quantity || v.available));
    if (notAvailable) return null;
    const comparedPrice = product.variants[0].compare_at_price
    product = filterProductOptions(product);
    return {
      images: (product.media || product.images).slice(0, 2).map((media) => ({
        originalSrc: (media?.preview_image?.src || media.src),
        alt: media.alt,
      })),
      productType: product.type || product.product_type,
      price: product.variants[0].price / 100,
      compareAtPrice: comparedPrice ? comparedPrice / 100 : null,
      handle: product.handle,
      title: product.title,
      id: product.id,
      options: Object.entries(product.options).map(([key, values]) => ({
        name: key,
        values,
      })),
      createdAt: product.updated_at || product.created_at,
      variants: product.variants.map((v) => ({
        availableForSale: !!v.inventory_quantity || v.available,
        title: v.title,
        id: v.id,
        compareAtPrice: v.compare_at_price ?  v.compare_at_price / 100 : null,
        price: v.price / 100,
        options: [v.option1, v.option2, v.option3].filter(Boolean),
        sku: v.sku,
      })),
    };
  })
);

export const restructureStorefrontProducts = (products, collectionObj) => (
  products.map((product) => {
    if (!product.node.availableForSale) return null;

    let compareAtPrice = null;
    if (product.node.compareAtPriceRange.maxVariantPrice.amount > 0) {
      compareAtPrice = product.node.compareAtPriceRange.maxVariantPrice.amount
    }

    const productObj = {
      id: parseGraphQlId(product.node.id),
      available: product.node.availableForSale,
      handle: product.node.handle,
      productType: product.node.productType,
      title: product.node.title,
      tags: product.node.tags,
      images: product.node.images.edges.map(({ node }) => ({ ...node })),
      price: product.node.priceRange.minVariantPrice.amount,
      compareAtPrice,
      options: product.node.options,
      variants: product.node.variants.edges.map(({ node }) => ({
        ...node,
        id: parseGraphQlId(node.id),
        options: node.title.split(' / '),
      })),
    };
    if (collectionObj) {
      productObj.collectionHandle = collectionObj.handle;
      productObj.collectionTitle = collectionObj.title;
      productObj.lastPage = !collectionObj.products.pageInfo.hasNextPage;
    }
    return productObj;
  }).filter(Boolean)
);

const filterProductOptions = (product) => {
  const options = {};
  if (product.options && product.options.length) {
    product.variants.forEach((v) => {
      product.options.forEach((opt, optIndex) => {
        if (typeof opt === 'object') {
          options[opt.name] = opt.values;
          return;
        }
        if (!(opt in options)) {
          options[opt] = [];
        }
        options[opt].push(v[`option${optIndex + 1}`]);
        options[opt] = options[opt].filter((val, i, self) => (
          self.indexOf(val) === i
        ));
      });
    });
  }
  return { ...product, options };
};

export const fetchRebuyRecommendedProducts = async (productIds, count) => {
  const { data: { data } } = await axios(`${rebuyUrl}/recommended?key=${rebuyApiKey}&shopify_product_ids=${productIds.join(',')}&limit=${count}`);
  const product = await fetchProductsById(data);
  return product;
};

export const fetchCollectionProducts = async (collectionHandle, productsCount) => {
  const {
    data: { data },
  } = await axios({
    ...storefrontConfig,
    data: `{
      collection(handle:"${collectionHandle}") {
        products(first:${productsCount}) {
          ${createProductItemBody(10)}
        }
      }
    }`,
  });
  return restructureStorefrontProducts(
    data.collection.products.edges
  );
};